
export default {
  name: 'Downloads',
  props: {
    titleTranslationKey: {
      type: String,
      default: 'front.downloads.manual',
    },
    downloads: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    manuals() {
      if (
        !Array.isArray(this.downloads?.manual) ||
        this.downloads?.manual?.length === 0
      )
        return false

      return this.downloads.manual.map((item) => ({
        title: item?.title || '',
        url: item?.file?.src || '',
        updatedAt: item?.updatedAt || '',
        type: 'file',
      }))
    },
    links() {
      if (
        !Array.isArray(this.downloads?.links) ||
        this.downloads?.links?.length === 0
      )
        return false

      return this.downloads.links.map((item) => ({
        title: item?.title || '',
        url: item?.link || '',
        type: 'link',
      }))
    },
    faqs() {
      if (
        !Array.isArray(this.downloads?.faqs) ||
        this.downloads?.faqs?.length === 0
      )
        return false

      return this.downloads.faqs.map((item) => ({
        title: item?.title || '',
        url: item?.link || '',
        type: 'link',
      }))
    },
    content() {
      return this.downloads.content?.content
    },
  },
}
